<script>
    import WaitingMixin from 'fundation-app-vuejs/src/components/partials/waitingMixin/index.vue';

    export default {
        name: 'PreviewStepMixin',

        mixins: [WaitingMixin],

        props:{
            stepData: {
                type: Object,
                required: true,
            },
            preview: {
                type: Object,
                required: true,
            },
            isInStepper:{
                type: Boolean,
                default: true,
            },
            creationRequest: {
                type: Object,
                default: undefined
            },
            creationRequestParams:{
                type: Object,
            },
            skipLastStep:{
                type: Boolean,
                default: false,
            },
            previewQuota: {
                type:Object
            },
            hasCustomPreviewStep:{
                type: Boolean,
                default: false,
            },
            width:{
                type: Number,
            }
        },
        data(){
            return{
                showLoader: false,
            };
        },
        computed: {
            // dynamic style based on component width
            fontSize(){
                return `${this.width/20}px`
            },
            margin(){
                return `${this.width/50}px`
            }
        },
        methods: {
            createNewPreview(stop = false){
                if(stop){
                    this.$emit('stopAndCreateNewPreview');
                }else{
                    this.$emit('createNewPreview');
                }
            },
            createPreviewRequest(context, requestModelName, requestModelUrl ,stopPreview = false, requestScopes = null){
                if(stopPreview){
                    clearInterval(this.fetchInterval);
                    this.stopPreview();
                }
                return this.$store.dispatch('createItem',{
                    item: context,
                    model: requestModelName,
                    url: requestModelUrl,
                    scopes: requestScopes
                });
            },
            changeStep(step){
                this.$emit('changeStep', step);
            },
            cancelPreview(action){

                if(action === 'cancel'){
                    this.stopPreview()
                    .then(()=>{
                        this.changeStep(6);
                    });
                }else {
                    this.stopPreview()
                    .then((response)=>{
                        this.watchModelStatus(response, 'COMPLETED', 'FAILED')
                        .then(()=>{
                            this.showLoader = false;
                            if(this.skipLastStep){
                                this.$emit('setToOriginalStep');
                            }else{
                                this.changeStep(7);
                            }
                        })
                        .catch(()=>{
                            this.showLoader = false;
                        });
                        this.showLoader = true;
                    });
                }
            },
            stopPreview(){
                if(this.preview){
                    this.creationRequestParams.context['preview_uid'] = this.preview.uid;
                }
                return this.$store.dispatch('createItem',{
                    item: this.creationRequestParams.context,
                    model: 'previewChangeRequest',
                    url: this.$store.state.api.meta.listModels.previewChangeRequest.url
                });
            },
            async createAndWatchRequest(context, requestModelName, requestModelUrl){
                return this.$store.dispatch('createItem',{
                    item: context,
                    model: requestModelName,
                    url:  requestModelUrl
                }).then((response)=>{
                    return new Promise((resolve, reject) => {
                        let request = response;
                        let interval = setInterval(async ()=>{
                            if(request.status === 'COMPLETED'){
                                resolve();
                                clearInterval(interval);
                            } else if(request.status === 'FAILED'){
                                reject(request.verbose_status);
                                clearInterval(interval);
                            }
                            this.$store.dispatch('remoteGet', { url : request.url })
                            .then(response =>{
                                request = response.data;
                            });
                        }, 3000);
                    });
                });
            },
            async watchModelStatus(itemToWatch, successStatus, failedStatus = null){
                return new Promise((resolve, reject) => {
                    let item = itemToWatch;
                    let interval = setInterval(async ()=>{
                        if(item.status === successStatus){
                            resolve(item);
                            clearInterval(interval);
                        }
                        if(failedStatus !== null && item.status === failedStatus){
                            reject(item);
                            clearInterval(interval);
                        }
                        this.$store.dispatch('remoteGet', { url : itemToWatch.url })
                        .then(response =>{
                            item = response.data;
                        });
                    }, 3000);
                });
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Mixins/preview-step-mixin.vue